// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b674e440","879":"0b97ef05"}[chunkId] + ".chunk.js";
};